import React, { Component } from 'react';
import { withSnackbar } from 'notistack';

import { compose } from 'redux';
import { DialogContent, FormHelperText } from '@mui/material';
import { PubSub } from '../../utils/eventUtils';
import { deleteAccount } from '../../accounts/AccountService';

import { withQueryClient } from '../hocs/withQueryClient';
import { withToggleModal } from '../hocs/withToggleModal';
import { queries } from '../../queries';

class AdminAccountsDeleteConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountName: '',
      accountId: '',
      error: '',
    };
  }

  componentDidMount() {
    const {
      props: { data },
    } = this;
    this.setState({
      accountName: data.name,
      accountId: data.id,
    });

    this.subscription = PubSub.subscribe('foot-button-one', (eventData) => {
      if (eventData) {
        this.handleSubmit();
      }
    });
  }

  componentWillUnmount() {
    this.subscription.remove();
  }

  handleSubmit = () => {
    const { queryClient } = this.props;

    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);
    deleteAccount(this.state.accountId)
      .then(() => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.props.toggleModal.direct('AdminAccountsDeleteConfirm', false);
        this.props.enqueueSnackbar('Account Deleted Successfully!', {
          variant: 'success',
        });

        queryClient.invalidateQueries(queries.accounts.list._def);
      })
      .catch((error) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.setState({ error: error.response.data });
      });
  };

  render() {
    return (
      <DialogContent>
        <div className="modal-title">
          Are you sure you want to delete the account
          <span className="modal-blue-text"> {this.state.accountName}</span>?
        </div>
        <FormHelperText className="api-text-error">
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

AdminAccountsDeleteConfirm.defaultProps = {
  data: {},
};

export default compose(
  withSnackbar,
  withQueryClient,
  withToggleModal
)(AdminAccountsDeleteConfirm);
